import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './VHubAiPage.css';
import { NetworkManager } from '../../Components/NetworkManager';




const VHubAiPage = () => {
  const iframeRef = useRef<any>(null);
  const location = useLocation();
  const baseUrl = "https://d2rx7528f4g2up.cloudfront.net";
  const path = location.pathname.replace(/^\/vhubai/, "");
  const iframeSrc = `${baseUrl}${path}`;
  console.log(iframeSrc, "iframeSrc");
  const getDbSchemaFromServerPath = (serverPath: string) => {
    if (!serverPath) return "";

    let host = serverPath;
    try {
      host = new URL(serverPath).host.toLowerCase();
    } catch (e) {
      host = serverPath.toLowerCase();
    }

    if (host.includes('apiqa.')) return 'QA';
    if (host.includes('apistaging.')) return 'Staging';
    if (host.includes('universalapi.') || host.includes('vhubapp.com')) return 'Universal';
    return '';
  };

  useEffect(() => {
    const sendMessage = () => {
      const serverPath = NetworkManager.serverPath || "";
      const data = { 
        token: `${localStorage.getItem("token")}`,
        orgName: `${localStorage.getItem("orgName")}` ,
        user: `${localStorage.getItem("user")}`,
        dbSchema: getDbSchemaFromServerPath(serverPath),
      };
      console.log(data, "iFramedata");
      if (iframeRef.current) {
        iframeRef.current.contentWindow?.postMessage(data, "*")
      }
    };

    const handleMessage = (event: any) => {
      if (event.data.type === "VHUB_READY") {
        sendMessage();
        console.log("Received in B:", event.data.value);
      }
    };

    // Add listener when component mounts
    window.addEventListener('message', handleMessage);

    // Clean up listener when component unmounts to prevent memory leaks
    return () => window.removeEventListener('message', handleMessage);
  }, []);

    return (
        <div>
          <div className="vhub-ai-container">
              <iframe
                ref={iframeRef}
                src={iframeSrc}
                name="vhubAiFrame"
                title="vHub AI"
                className="vhub-ai-iframe"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
          </div>
        </div>
    );
};

export default VHubAiPage;